import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const LocationFilterTitle = styled.div`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleHeading
      : textStyleCss(theme.atlas.typography.semantic.body)}
`;
